import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const TIMEZONES = [
  { value: 'America/Denver', label: 'America/Denver' },
  { value: 'America/Chicago', label: 'America/Chicago' },
  { value: 'America/New_York', label: 'America/New York' },
  { value: 'America/Los_Angeles', label: 'America/Los Angeles' },
  { value: 'Pacific/Honolulu', label: 'Pacific/Honolulu' },
  { value: 'America/Phoenix', label: 'America/Phoenix' },
  { value: 'Europe/London', label: 'Europe/London' },
  { value: 'Europe/Zurich', label: 'Europe/Zurich' },
  { value: 'America/Indiana/Indianapolis', label: 'America/Indiana/Indianapolis' },
  { value: 'Australia/Sydney', label: 'Australia/Sydney' },
  { value: 'America/Detroit', label: 'America/Detroit' },
  { value: 'America/Vancouver', label: 'America/Vancouver' },
  { value: 'America/Anchorage', label: 'America/Anchorage' },
  { value: 'America/Boise', label: 'America/Boise' },
  { value: 'America/Edmonton', label: 'America/Edmonton' },
  { value: 'America/Santo_Domingo', label: 'America/Santo Domingo' },
  { value: 'America/Grand_Turk', label: 'America/Grand Turk' },
  { value: 'America/Curacao', label: 'America/Curacao' },
  { value: 'America/Toronto', label: 'America/Toronto' },
  { value: 'America/St_Johns', label: 'America/St Johns' },
  { value: 'America/Halifax', label: 'America/Halifax' },
];

export const DEFAULT_TEMPLATE_BUTTONS = [
  { value: ':name:', label: 'Client Name' },
  { value: ':review:', label: 'Review Link' },
  { value: ':store:', label: 'Store Name' },
  { value: ':associate:', label: 'Associate Name' },
];

export const MASS_MESSAGE_TEMPLATE_BUTTONS = [
  { value: ':name:', label: 'Client Name' },
  { value: ':review:', label: 'Review Link' },
  { value: ':store:', label: 'Store Name' },
  { value: ':associate:', label: 'Associate Name' },
];

export const MASS_MESSAGE_SEND_WINDOW = {
  startHour: 9,
  endHour: 19,
};

export const MASS_MESSAGE_SEND_WINDOW_ERROR = 'Please select a time between 9:00am and 7:00pm';
export const MASS_MESSAGE_FUTURE_TIME_ERROR = 'Please select a future date and time';

export const getScheduledDateTimeInTimezone = (scheduledDate, selectedTimezone) => {
  if (!scheduledDate || !selectedTimezone) {
    return null;
  }

  const localTimeString = scheduledDate.format('YYYY-MM-DDTHH:mm:ss');
  return dayjs.tz(localTimeString, selectedTimezone);
};

export const isMassMessageScheduleInFuture = (scheduledDate, selectedTimezone, now = dayjs()) => {
  const scheduledInTimezone = getScheduledDateTimeInTimezone(scheduledDate, selectedTimezone);
  return scheduledInTimezone?.isAfter(now) ?? false;
};

export const getDisabledPastTime = (current, selectedTimezone, now = dayjs()) => {
  if (!current || !selectedTimezone) {
    return {};
  }

  const nowInTimezone = now.tz(selectedTimezone);
  if (current.format('YYYY-MM-DD') !== nowInTimezone.format('YYYY-MM-DD')) {
    return {};
  }

  const currentHour = nowInTimezone.hour();
  const currentMinute = nowInTimezone.minute();
  return {
    disabledHours: () => Array.from({ length: currentHour }, (_, hour) => hour),
    disabledMinutes: hour =>
      hour === currentHour ? Array.from({ length: currentMinute + 1 }, (_, minute) => minute) : [],
  };
};

const getTimePart = (date, dayjsGetter, dateGetter) => {
  if (!date) {
    return 0;
  }

  if (typeof date[dayjsGetter] === 'function') {
    return date[dayjsGetter]();
  }

  if (typeof date[dateGetter] === 'function') {
    return date[dateGetter]();
  }

  return 0;
};

export const isMassMessageSendWindowTime = date => {
  if (!date) {
    return false;
  }

  const { startHour, endHour } = MASS_MESSAGE_SEND_WINDOW;
  const hour = getTimePart(date, 'hour', 'getHours');
  const minute = getTimePart(date, 'minute', 'getMinutes');
  const second = getTimePart(date, 'second', 'getSeconds');
  const millisecond = getTimePart(date, 'millisecond', 'getMilliseconds');
  const selectedTime = hour * 60 * 60 * 1000 + minute * 60 * 1000 + second * 1000 + millisecond;
  const windowStart = startHour * 60 * 60 * 1000;
  const windowEnd = endHour * 60 * 60 * 1000;

  return selectedTime >= windowStart && selectedTime <= windowEnd;
};

export const defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const LARGE_AUDIENCE_THRESHOLD = 5000;
